import React from 'react';
import { type LayerConfig } from '../../../types/metadata';

interface PolygonLayerItemProps {
  layer: LayerConfig;
}

export const PolygonLayerItem: React.FC<PolygonLayerItemProps> = ({ layer }) => {
  return (
    <>
      <div className="detail-item">
        <svg width="14" height="14" viewBox="0 0 24 24" fill={`rgb(${layer.polygonSettings!.color.join(',')})`} stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" />
        </svg>
        <span>Polygon Layer</span>
      </div>
      <div className="detail-item">
        <span style={{ fontSize: '14px' }}>🔍</span>
        <span>No Filters - All items</span>
      </div>
    </>
  );
};
